import { useQuery } from '@tanstack/react-query';
import type { PlatformChatRankingCriteria } from '@liks/lac-svc-api/esm/models/index';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import type { LacTenantOverviewDateRange } from '../../../types/lac';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacTopPlatformChatsQuery(
  tenantName: string | undefined,
  criteria: PlatformChatRankingCriteria,
  knowledgeBaseId?: string | null,
  range?: LacTenantOverviewDateRange,
) {
  return useQuery({
    queryKey: lacQueryKeys.topPlatformChats(
      tenantName ?? '',
      criteria,
      knowledgeBaseId ?? null,
      range ?? null,
    ),
    enabled: Boolean(tenantName),
    queryFn: () => {
      if (!tenantName) {
        throw new Error('Missing tenant name');
      }
      return lacAnalyticsService.listTopPlatformChats({
        tenantName,
        criteria,
        knowledgeBaseId,
        range,
      });
    },
  });
}
